import React, {
  createContext,
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  useContext,
  useState,
} from 'react';

import { Cycle } from 'types/Cycle';

export type GlobalState = {
  // The cycle pages show. It follows the org unit's current cycle until the
  // user pins one via the switcher or a deep link; a pinned cycle then sticks
  // across pages until the next full page load.
  selectedCycle: Cycle;
  isCyclePinned: boolean;
};

type GlobalStateContextType = [
  GlobalState,
  Dispatch<SetStateAction<GlobalState>>
];

const GlobalStateContext = createContext<GlobalStateContextType>(null);

export const useGlobalState = () => {
  const context = useContext(GlobalStateContext);
  if (!context) {
    throw new Error('useGlobalState must be used within a GlobalStateProvider');
  }
  return context;
};

export const GlobalStateProvider = ({
  initialState,
  children,
}: PropsWithChildren<{ initialState: GlobalState }>) => {
  const globalState = useState(initialState);

  return (
    <GlobalStateContext.Provider value={globalState}>
      {children}
    </GlobalStateContext.Provider>
  );
};
